export enum ChangeType {
	Add = "Add",
	Delete = "Delete",
	NoChange = "NoChange"
}